module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unlock":"","tariffs":"Available plans"}}')
  delete Component.options._Ctor
}
